<template>
  <div class="result">
    <AppNavbar
      v-if="isApp"
      :options="options"
      :zIndex="999"
      title="7日营养菜谱"
    >
      <div slot="right" id="right-icon">
        <van-popover
          v-model="showPopover"
          trigger="click"
          theme="dark"
          placement="bottom-end"
          :offset="[12, 10]"
          :actions="actions"
          @select="onSelect"
          get-container="#right-icon"
        >
          <template #reference>
            <div class="more-icon iconfont icon-gengduo1"></div>
          </template>
        </van-popover>
        <!-- <div
          @click="bindSaveImage"
          v-buried
          :data-buried="buriedData[active].buried"
          v-clickBuried
          :data-click-buried="buriedData[active].clickBuried"
          ><span class="explain iconfont icon-download"></span
          ><span>保存图片</span></div
        > -->
      </div>
    </AppNavbar>
    <div class="container">
      <TopContent class="t-content" />
      <div class="content" v-if="navList.length">
        <div class="nav-container">
          <van-tabs
            class="tabs-content"
            v-model="active"
            line-width="12"
            line-height="3"
            color="#66CCBA"
            swipeable
          >
            <van-tab
              :title="item.title"
              v-for="(item, index) in navList"
              :key="index"
            >
              <template #title>
                <div
                  v-buried
                  :data-buried="navBuriedData[index].buried"
                  v-clickBuried
                  :data-click-buried="navBuriedData[index].clickBuried"
                  >{{ item.title }}</div
                >
              </template>
              <div class="list-content">
                <div class="list-wraper">
                  <div class="content-item" v-show="active == index">
                    <div class="day-content">
                      <div class="day-list">
                        <div
                          class="day-item"
                          @click="bindClickDay(item, index, dayIndex)"
                          :class="{
                            'day-item-active': dayIndex == item.active
                          }"
                          v-for="(dayItem, dayIndex) in item.data"
                          :key="dayIndex"
                          >第{{ dayItem.day }}天</div
                        >
                      </div>
                    </div>
                    <div class="food-content">
                      <div class="food-scoll-wrapper">
                        <div
                          class="food-scroll"
                          :class="{ 'food-scrolling': item.autoScroll }"
                          :id="'scroll-' + index"
                          @scroll.passive="bindScroll($event, index)"
                          @touchstart="bindTouchStart(item)"
                        >
                          <div class="scroll-padding">
                            <div
                              class="food-day"
                              :id="'day-' + index + '-' + dayIndex"
                              v-for="(dayItem, dayIndex) in item.data"
                              :key="dayIndex"
                            >
                              <div class="food-title"
                                >第{{ dayItem.day }}天</div
                              >
                              <div class="food-diet-list">
                                <div
                                  class="food-diet-item"
                                  v-for="(dietItem, dietIndex) in dayItem.data"
                                  :key="dietIndex"
                                >
                                  <div class="food-diet-item-title"
                                    ><span class="diet-name">{{
                                      dietItem.meal_name
                                    }}</span
                                    ><span class="diet-time">{{
                                      timeObj[dietItem.meal_name]
                                    }}</span>
                                  </div>
                                  <MakeFood
                                    v-if="index == 0"
                                    @into="bindFoodItem"
                                    @order="bindFoodOrder"
                                    :data="dietItem.meal_data"
                                  />
                                  <TakeawayFood
                                    v-if="index == 1"
                                    @into="bindFoodItem"
                                    @order="bindFoodOrder"
                                    :data="dietItem.meal_data"
                                  />
                                  <div
                                    class="recommend-content"
                                    v-if="
                                      dietItem.recommend_recipe &&
                                      dietItem.recommend_recipe.length
                                    "
                                  >
                                    <div>推荐菜：</div>
                                    <div class="recommend-list">
                                      <span
                                        class="recommend-item"
                                        @click="
                                          bindRecommendRecipe(recommenditem)
                                        "
                                        v-for="(
                                          recommenditem, recommendindex
                                        ) in dietItem.recommend_recipe"
                                        :key="recommendindex"
                                        ><span class="r-name">{{
                                          recommenditem.name
                                        }}</span
                                        ><span
                                          v-if="
                                            recommendindex <
                                            dietItem.recommend_recipe.length - 1
                                          "
                                          >、</span
                                        >
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </van-tab>
          </van-tabs>
        </div>
        <div
          class="toggle-btn"
          v-if="allowToggle && showOpen"
          @click="bindOpenRecipe"
          >启用该食谱</div
        >
        <div
          class="toggle-btn"
          v-if="allowToggle && showReplace"
          @click="clickReplaceRecipe"
          >启用该食谱</div
        >
      </div>
      <van-loading size="24px" class="loading" v-if="loading"
        >加载中...</van-loading
      >
      <!-- 点外卖 -->
      <van-overlay
        :show="showOrder"
        @click.stop="showOrder = false"
        z-index="1000"
      >
        <OrderPopup
          v-if="showOrder"
          @close="bindHideOrder"
          :buriedData="orderBuriedData"
        />
      </van-overlay>
      <van-overlay :show="showJumpToast" @click.stop z-index="1000">
        <div class="jump-toast">{{ jumpToastText }}</div>
      </van-overlay>
      <!-- 海报 -->
      <CnaPoster ref="poster" :posterType="posterType" />
    </div>
    <van-overlay :show="showToast" z-index="3000">
      <div class="wrapper" @click.stop v-if="toastData">
        <img class="w-image" :src="toastData.image" alt="" />
        <div class="w-title" v-if="toastData.title">{{ toastData.title }}</div>
        <div class="w-content">
          <div class="w-text" v-html="toastData.text"></div>
          <div class="w-btn" @click="bindClose">确认</div>
        </div>
      </div>
    </van-overlay>
    <van-overlay
      :show="showCloseToast"
      @click="showCloseToast = false"
      z-index="2100"
    >
      <div @click.stop class="toast-wrapper">
        <CloseRecipeToast
          @confirm="bindStopRecipe"
          @cancel="showCloseToast = false"
        />
      </div>
    </van-overlay>
    <van-overlay
      :show="showReplaceToast"
      @click="showReplaceToast = false"
      z-index="2100"
    >
      <div @click.stop class="toast-wrapper">
        <ReplaceRecipeToast
          :text="replaceToastText"
          @confirm="bindReplaceRecipe"
          @cancel="showReplaceToast = false"
        />
      </div>
    </van-overlay>
  </div>
</template>
<script>
import CnaPoster from './components/result/poster.vue'
import AppNavbar from '@/components/app/nav-bar/index.vue'
import TopContent from './components/result/top-content.vue'
import OrderPopup from '../eating-today/components/order.vue'
import MakeFood from './components/result/make-food.vue'
import TakeawayFood from './components/result/takeaway-food.vue'
import CloseRecipeToast from './components/dialog/close.vue'
import ReplaceRecipeToast from './components/dialog/replace.vue'
import { mapActions } from 'vuex'
export default {
  name: 'cna-question-v2-recipe',
  components: {
    AppNavbar,
    TopContent,
    OrderPopup,
    CnaPoster,
    MakeFood,
    TakeawayFood,
    CloseRecipeToast,
    ReplaceRecipeToast
  },
  data() {
    return {
      isApp: false,
      options: {
        barBackgroundColor: 'transparent',
        color: '#fff'
      },
      showCloseToast: false,
      showReplaceToast: false,
      replaceToastText: '',
      showPopover: false,
      userRecipe: null,
      navList: [],
      active: 0, //当前选中的食谱类型
      showOrder: false,
      jumpToastText: '',
      showJumpToast: false,
      loading: false,
      showToast: false,
      toastData: {
        image:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a6c824b1afb3d1e0317c24c0d8dd1851.png',
        title: '温馨提示',
        text: '结合您目前的身体问题、服用药物、过敏忌口等信息，无法为您生成合理的科学定制营养方案，请<span style="color:#9890FD">联系客服</span>或<span style="color:#9890FD">您的营养师</span>寻求方案。'
      },
      buriedData: [
        {
          buried: 'BG_QRCAIPU_ZIZHI_BAOCUN',
          clickBuried: 'CLICK_QRCAIPU_ZIZHI_BAOCUN'
        },
        {
          buried: 'BG_QRCAIPU_WAIMAI_BAOCUN',
          clickBuried: 'CLICK_QRCAIPU_WAIMAI_BAOCUN'
        }
      ],
      orderBuriedData: [
        {
          buried: 'BG_QRCAIPU_WM_MT',
          clickBuried: 'CLICK_QRCAIPU_WM_MT'
        },
        {
          buried: 'BG_QRCAIPU_WM_ELM',
          clickBuried: 'CLICK_QRCAIPU_WM_ELM'
        }
      ],
      navBuriedData: [
        {
          buried: 'BG_QRCAIPU_ZIZHI_TAB',
          clickBuried: 'CLICK_QRCAIPU_ZIZHI_TAB'
        },
        {
          buried: 'BG_QRCAIPU_WM_TAB',
          clickBuried: 'CLICK_QRCAIPU_WM_TAB'
        }
      ],
      timeObj: {
        早餐: '6:30 - 9:30',
        午餐: '11:30 - 14:30',
        加餐: '15:00 - 16:00',
        晚餐: '17:30 - 19:30'
      },
      autoScroll: false
    }
  },
  watch: {
    active() {
      this.scrollToPosition()
    },
    $route(to, from) {
      if (
        from.path == '/cna-question-v2/result' &&
        to.path == '/cna-question-v2/recipe'
      ) {
        this.active = +this.$route.query.active || 0
        this.initScrollTop()
      }
    }
  },
  computed: {
    posterType() {
      return this.active ? 2 : 1
    },
    allowToggle() {
      return this.$route.query.from == 'recipe'
    },
    actions() {
      let res = [{ text: '保存图片', id: 2 }]
      if (this.allowToggle && this.isOpenCurRecipe) {
        res.unshift({ text: '结束食谱', id: 1 })
      }
      return res
    },
    isOpenCurRecipe() {
      let id = this.$route.query.id
      return (
        this.userRecipe &&
        this.userRecipe.ref_id == id &&
        this.userRecipe.use_state == 1 &&
        this.userRecipe.recipes_type == 1
      )
    },
    showReplace() {
      let id = this.$route.query.id
      return (
        this.userRecipe &&
        this.userRecipe.ref_id != id &&
        this.userRecipe.use_state == 1
      )
    },
    showOpen() {
      return this.userRecipe && this.userRecipe.use_state != 1
    }
  },
  created() {
    this.isApp = this.$betterwe.isApp()
    this.active = +this.$route.query.active || 0
  },
  activated() {
    this.navList = []
    this.initNav()
    this.scrollToPosition()
    this.getUserRecipe()
  },
  mounted() {},
  methods: {
    ...mapActions('cnaV2', ['getMenuData']),
    async getUserRecipe() {
      let res = await this.$http
        .getBaseApp('api/v1/DiverseRecipesSquare/getUserRecipe')
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.userRecipe =
            Object.prototype.toString.call(res.data) == '[object Object]'
              ? res.data
              : { use_state: 0, ref_id: 0, recipes_type: 0 }
        }
      }
    },
    async bindOpenRecipe() {
      let id = this.$route.query.id
      let params = {
        ref_id: id,
        recipes_type: 1
      }
      let res = await this.$http
        .postBaseApp('api/v1/DiverseRecipesSquare/enableRecipe', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.$toast('开启成功')
          this.userRecipe.ref_id = id
          this.userRecipe.use_state = 1
          this.userRecipe.recipes_type = 1
        }
      }
    },
    async bindStopRecipe() {
      let res = await this.$http
        .postBaseApp('api/v1/DiverseRecipesSquare/endRecipe')
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.showCloseToast = false
          this.$toast('结束成功')
          this.userRecipe.ref_id = 0
          this.userRecipe.use_state = 2
          this.userRecipe.recipes_type = 0
        }
      }
    },

    async bindReplaceRecipe() {
      let id = this.$route.query.id
      let params = {
        ref_id: id,
        recipes_type: 1
      }
      let res = await this.$http
        .postBaseApp('api/v1/DiverseRecipesSquare/enableRecipe', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.showReplaceToast = false
          this.$toast('替换成功')
          this.userRecipe.ref_id = id
          this.userRecipe.use_state = 1
          this.userRecipe.recipes_type = 1
        }
      }
    },
    clickReplaceRecipe() {
      let name = this.userRecipe.recipes_name || '食谱'
      this.replaceToastText = `启用食谱将会更换正在使用中的“${name}”，确定要更换食谱吗？`
      this.showReplaceToast = true
    },
    onSelect(actions, index) {
      let id = actions.id
      switch (id) {
        case 1:
          this.showCloseToast = true
          break
        case 2:
          this.bindSaveImage()
          break
      }
    },
    bindClose() {
      this.showToast = false
      this.$router.go(-1)
    },
    //初始化滚动位置为0
    initScrollTop() {
      this.navList.map((item) => {
        item.scrollTop = 0
      })
    },
    //滚动到指定位置
    scrollToPosition() {
      this.$nextTick(() => {
        let el = document.getElementById('scroll-' + this.active)
        if (el) {
          el.scrollTop = this.navList[this.active].scrollTop
        }
      })
    },
    initNav() {
      let list = this.$store.state.cnaV2.menuData
      if (!list) {
        this.loading = true
        this.getMenuData()
          .then((res) => {
            if (res.code == 200) {
              list = this.$store.state.cnaV2.menuData
              this.navList = list.map((item) => {
                let obj = Object.assign({}, item)
                obj.active = 0
                obj.scrollTop = 0
                return obj
              })
            } else if (res.code == 421) {
              this.showToast = true
            } else {
              this.$toast(res.msg)
            }
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.navList = list.map((item) => {
          let obj = Object.assign({}, item)
          obj.active = 0
          obj.scrollTop = 0
          return obj
        })
      }
    },
    bindRecommendRecipe(item) {
      this.$betterwe.jumpRoute('/recipeDetails?id=' + item.id)
    },
    //关闭外卖弹框
    async bindHideOrder(item) {
      console.log(item)
      this.showOrder = false
      if (!item) {
        return
      }
      let version = await this.$betterwe.getAppVersion()
      let text = '正在为您跳转' + item.toast
      this.jumpToastText = text
      this.showJumpToast = true
      setTimeout(() => {
        this.showOrder = false
        this.showJumpToast = false
        setTimeout(() => {
          if (version < 90) {
            this.$betterwe.jumpMiniProgram({
              appId: item.username,
              path: encodeURIComponent(item.path + this.selectOrderFood)
            })
          } else {
            //美团可以根据关键字进行搜索，饿了么则不可以
            let appPath =
              item.launchUrlApp + (item.id == 1 ? this.selectOrderFood : '')
            this.$betterwe.launchUrlApp(appPath, (res) => {
              if (!+res) {
                //如果res = 0 跳转app失败则跳转小程序
                this.$betterwe.jumpMiniProgram({
                  appId: item.username,
                  path: encodeURIComponent(item.path + this.selectOrderFood)
                })
              }
            })
          }
        }, 300)
      }, 700)
    },
    bindFoodItem(item) {
      if (item.is_super) {
        //超级食物
        this.$router.push({
          path: '/calorie-query/super-food-detail',
          query: {
            id: item.cal_food_id
          }
        })
      } else if (item.menu_type == 2) {
        //菜谱
        this.$betterwe.jumpRoute('/recipeDetails?id=' + item.super_recipe_id)
      } else {
        //普通食物
        this.$router.push({
          path: '/calorie-query/food-info',
          query: {
            foodid: item.cal_food_id
          }
        })
      }
    },
    bindFoodOrder(item) {
      this.selectOrderFood = item.name
      this.showOrder = true
    },

    bindTouchStart(item) {
      item.autoScroll = false
    },
    bindScroll(e, index) {
      //vue单页面不能保留元素的滚动高度，所以需要保存当前滚动高度
      if (index == this.active) {
        this.navList[index].scrollTop = e.target.scrollTop
      }
      if (this.navList[index].autoScroll) {
      } else {
        this.navList[index].active = this.getCurDay(index)
      }
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer)
      }
    },
    bindSaveImage() {
      this.$refs.poster.start()
    },
    bindClickDay(item, index, dayIndex) {
      item.active = dayIndex
      item.autoScroll = true
      this.$nextTick(() => {
        this.scrollToId(index, dayIndex)
      })
    },
    //滚动到指定id元素的位置
    scrollToId(index, dayIndex) {
      let scrollEl = document.getElementById('scroll-' + index)
      let dayEl = document.getElementById('day-' + index + '-' + dayIndex)
      scrollEl.scrollTop = dayEl.offsetTop
      /* 解决ios元素滚动时设置scrollTop会导致滚动区域白屏的问题 滚动一次之后在100ms在设置一次解决白屏问题 */
      setTimeout(() => {
        scrollEl.scrollTop = dayEl.offsetTop
      }, 100)
    },
    //自动定位第几天
    getCurDay(index) {
      for (let i = 0; i < this.navList[index].data.length; i++) {
        let contentEl = document.getElementById('scroll-' + index)
        let itemEl = document.getElementById('day-' + index + '-' + i)
        if (this.isInViewPort(contentEl, itemEl)) {
          return i
        }
      }
      return this.navList[index].data.length - 1
    },
    //是否在可视区域
    isInViewPort(content, item) {
      return (
        content.scrollTop + content.offsetHeight - item.offsetTop > 0 &&
        content.scrollTop +
          content.offsetHeight -
          (item.offsetTop + item.offsetHeight) <
          0
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.result {
  ::v-deep .van-popover__content {
    background-color: rgba(48, 48, 56, 0.6);
  }
  ::v-deep .van-popover__action {
    font-size: 12px;
    width: 80px;
    height: 36px;
    padding: 0;
    box-sizing: border-box;
  }
  ::v-deep .van-popover__arrow {
    border-bottom-color: rgba(48, 48, 56, 0.6);
  }
  ::v-deep .van-hairline--bottom::after {
    border-color: rgba(255, 255, 255, 0.1);
  }
  .more-icon {
    margin-right: 6px;
  }
}
.container {
  position: relative;
  height: 100vh;
  word-break: break-all;
  word-wrap: break-word;
  display: flex;
  align-items: stretch;
  flex-direction: column;

  .c-top {
    height: 190px;
    position: relative;

    .t-content {
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 20px;
    }
  }

  .content {
    position: relative;
    z-index: 1;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    width: 100%;
    background: #ffffff;
    border-radius: 16px 16px 0px 0px;
    margin-top: -16px;

    .nav-container {
      height: 100%;
    }

    ::v-deep .van-tab {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 22px;
      flex: none;
      padding: 0 10px;
    }

    ::v-deep .van-tabs__wrap {
      padding-top: 2px;
      height: 48px;
    }

    ::v-deep .van-tabs__nav--line {
      padding-bottom: 0;
    }

    ::v-deep .van-tabs__line {
      bottom: 8px;
    }

    ::v-deep .van-tab--active {
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
    }

    .tabs-content {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: stretch;
    }

    ::v-deep .van-tabs__content {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
    }

    ::v-deep .van-tab__pane {
      height: 100%;
    }

    ::v-deep .van-tabs__wrap {
      padding: 0 10px;
    }

    .list-content {
      height: 100%;

      .list-wraper {
        width: 100%;
        height: 100%;
        background: #f9f9f9;
      }

      .content-item {
        width: 100%;
        height: 100%;
        position: relative;

        .day-content {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 9;
          width: 90px;
          height: 100%;
          overflow-y: scroll;

          .day-list {
            padding: 16px 0px;

            .day-item {
              text-align: center;
              width: 75px;
              height: 36px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              color: rgba(0, 0, 0, 0.5);
              line-height: 36px;
              margin-bottom: 13px;
            }

            .day-item-active {
              font-weight: 600;
              color: rgba(0, 0, 0, 0.8);
              background: linear-gradient(
                90deg,
                rgba(102, 204, 187, 0.2) 0%,
                rgba(255, 255, 255, 0) 100%
              );
              border-radius: 0px 6px 6px 0px;
            }
          }
        }

        .food-content {
          height: 100%;
          padding-left: 90px;

          .food-scoll-wrapper {
            position: relative;
            height: 100%;
          }

          .food-scroll {
            position: relative;
            z-index: 1;
            width: 100%;
            height: 100%;
            overflow-y: scroll;
            padding-right: 16px;
            box-sizing: border-box;
            //scroll-behavior: smooth;
            -webkit-overflow-scrolling: touch;

            .scroll-padding {
              padding-top: 16px;
              padding-bottom: 70px;
            }

            .food-day {
              padding-bottom: 12px;

              .food-title {
                text-align: center;
                height: 24px;
                background: #f1f1f1;
                border-radius: 6px;
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: rgba(0, 0, 0, 0.5);
                line-height: 24px;
                margin-bottom: 10px;
              }

              .food-diet-list {
                .food-diet-item {
                  margin-bottom: 20px;

                  .food-diet-item-title {
                    margin-bottom: 10px;

                    .diet-name {
                      font-size: 14px;
                      font-family: PingFangSC-Medium, PingFang SC;
                      font-weight: 600;
                      color: rgba(0, 0, 0, 0.8);
                      line-height: 20px;
                      margin-right: 7px;
                    }

                    .diet-time {
                      font-size: 14px;
                      font-weight: 600;
                      color: rgba(0, 0, 0, 0.3);
                      line-height: 17px;
                    }
                  }

                  .recommend-content {
                    display: flex;
                    font-size: 12px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 600;
                    color: rgba(0, 0, 0, 0.8);
                    line-height: 17px;
                    margin-top: 8px;
                    padding: 4px 8px;
                    background: rgba(114, 208, 196, 0.15);
                    border-radius: 6px;
                  }

                  .recommend-list {
                    flex: 1;
                    flex-shrink: 0;
                    overflow: hidden;
                    font-size: 12px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 600;
                    color: #000000;

                    .recommend-item {
                      color: rgba(96, 195, 178, 1);

                      .r-name {
                        text-decoration: underline;
                      }
                    }
                  }
                }

                .food-diet-item:last-child {
                  margin-bottom: 0;
                }
              }
            }
          }

          .food-scrolling {
            -webkit-overflow-scrolling: auto;
          }
        }
      }
    }
  }
  .toggle-btn {
    z-index: 999;
    position: fixed;
    left: 50%;
    bottom: 34px;
    transform: translate(-50%, 0%);
    width: 303px;
    height: 38px;
    text-align: center;
    line-height: 38px;
    background: linear-gradient(324deg, #373a56 0%, #565e7a 100%);
    border-radius: 22px;
    font-weight: bold;
    font-size: 14px;
    color: #ffffff;
  }
}

.jump-toast {
  position: fixed;
  z-index: 9999;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  border-radius: 10px;
  padding: 20px 26px;
  white-space: nowrap;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;

  color: rgba(0, 0, 0, 0.8);
  line-height: 20px;
}

.loading {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.wrapper {
  overflow: hidden;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 295px;
  background: #ffffff;
  border-radius: 12px;

  .w-title {
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
    margin-bottom: 12px;
  }

  .w-image {
    width: 100%;
    height: 104px;
    object-fit: contain;
    min-height: 20px;
    margin-bottom: 2px;
  }

  .w-content {
    padding: 0px 20px 20px;
  }

  .w-text {
    margin-bottom: 26px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.8);
    line-height: 22px;
  }

  .w-btn {
    text-align: center;
    height: 44px;
    background: #9890fd;
    border-radius: 12px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 44px;
  }
}
.toast-wrapper {
  position: absolute;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
}
</style>
